export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fc550382d55ef2d756445ac77260e5b657dc659e9&name=fetchTypeahead!'